




































import { Component, Vue, Emit, Watch, Model, PropSync, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_allCountries, GQL_allCountries_allCountries} from '@/queries/__generated__/allCountries';
import { ALL_COUNTRIES } from '@/queries/Country';

@Component
export default class PhoneInput extends Vue {
  @Prop() private fetchedCountries?: GQL_allCountries_allCountries[];
  @Model('update-value', { type: String, required: true }) private value!: string | null;
  @PropSync('countryCode', { type: String, required: true }) private countryCodeSync!: string;
  @PropSync('phoneCode', { type: String, default: '' }) private phoneCodeSync!: string;
  private phoneCodeInternal: string = this.phoneCodeSync || '';
  private phoneNumber = this.value;

  @SmartQuery<PhoneInput, GQL_allCountries>({
    query: ALL_COUNTRIES,
    skip() { return !!this.fetchedCountries },
    result({ data }) {
      const selectedCountry = data.allCountries.find(c => c.code === this.countryCodeSync);

      if (selectedCountry) {
        this.phoneCodeSync = this.phoneCodeInternal = selectedCountry.phoneCode || '';
        this.phoneNumber = this.extractPhoneNumber(this.value, this.phoneCodeInternal);
      }
    },
  }) private allCountries!: GQL_allCountries_allCountries[];

  get countries() {
    return this.fetchedCountries || this.allCountries;
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @Watch('countryCodeSync', { immediate: true })
  private setPhoneCodeInternal(): void {
    if (!this.countries) return;

    const country = this.countries.find(c => c.code === this.countryCodeSync);

    if (country && country.phoneCode) {
      this.phoneCodeSync = this.phoneCodeInternal = country.phoneCode;
    } else {
      this.phoneCodeSync = this.phoneCodeInternal = '';
    }
  }

  @Watch('phoneCodeInternal')
  @Watch('phoneNumber')
  @Emit('update-value')
  private setFullPhoneNumber(): string {
    if (!this.phoneNumber) return '';
    return `${this.phoneCodeInternal}${this.phoneNumber}`;
  }

  private extractPhoneNumber(value: string | null, phoneCode: string): string {
    if (!value) return '';
    if (!phoneCode) return value;

    return value.split(phoneCode).filter(n => !!n)[0];
  }
}
